import {useState, useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty} from 'lodash'
import {useNavigate, useLocation} from 'react-router-dom'

import {useParams} from 'react-router-dom'
import CardBody from 'components/card/CardBody'
import CustomCard from 'components/card/CustomCard'
import CustomCardHeader from 'components/card/CustomCardHeader'
import {SemiTransparentButton} from 'components/CustomButton'
import CustomModal from 'components/CustomModal'
import PrescriptionForm from './PrescriptionForm'
import ImagePreview from 'components/images/ImagePreview'
import LabeledSelect from 'components/selects/LabeledSelect'
import CustomButton from 'components/CustomButton'
import {IconButton} from 'components/CustomButton'
import Loader from 'components/Loader'
import {
  getPharmacyPrescription,
  createPrescriptions,
  addAddress,
  deletePrescription,
  sendQuotation,
  confirmOrder,
  setResetPage,
  updateAddress,
  clearFormData
} from 'redux/slices/prescriptionSlice'
import JobCardLoader from 'pages/nuseCampaign/components/JobCardLoader'
import Input from 'components/form/Input'
import {AddressModal} from "../../../components/address/AddressModal";
import { setAddress } from 'redux/slices/addressSlice'

const CreatePrescriptions = ({activeTab}) => {
  const dispatch = useDispatch()
  const {order_id} = useParams()

  const [modalData, setModalData] = useState(undefined)
  const [activeModalComponent, setActiveModalComponent] = useState(undefined)
  const [selectedPrescription, setSelectedPrescription] = useState({})
  const [newAddress, setNewAddress] = useState({})
  const url = new URL(window.location.href)
  const navigate = useNavigate()
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);

  const {
    prescriptionInfo,
    processing,
    loader,
    // address,
    loading,
    error,
    resetPage,
  } = useSelector((state) => state.prescription)

  const {
    address,
  } = useSelector((state) => state.address);

  const [addressList, setAddressList] = useState([])
  const searchParam = useLocation().search

  const [selectedAddress, setSelectedAddress] = useState({})

  useEffect(() => {
    let addr = prescriptionInfo?.requester?.address ?? [];
    if(!isEmpty(address)){
      addr = [...addr, address]
    }
    //filter out the invalid address
    if (addr.length && isEmpty(selectedAddress)) {
      let addrList = setAddressLabel(addr);
      setAddressList(addrList)
      let defaultAddress = addrList?.find(
        (address) => address?.default_address,
      )
      setSelectedAddress(
        defaultAddress ?? addrList?.find((addr) => addr?.hasOwnProperty('landmark')),
      )
    }
    setIsAddressModalOpen(false);
    setModalData(undefined)

  }, [prescriptionInfo, address])


  useEffect(() => {
    const param = new URLSearchParams(searchParam)
    const status = param.get('status')
    // setActiveStatus(status)
    getPrescriptionInfo()
    return () => {
      dispatch(clearFormData())
      dispatch(setAddress())
    }
  }, [])

  useEffect(() => {
    if (resetPage) {
      dispatch(setResetPage(false))
      navigate('/prescription?page=1&tab=Processing', {
        replace: true,
      })
    }
  }, [resetPage])

  const getPrescriptionInfo = () => {
    dispatch(getPharmacyPrescription(order_id))
  }

  useEffect(() => {
    if (!isEmpty(address)) {
      let selectedAddress = {
        ...address,
        ...(address.area !== undefined && {address: `${address?.area?.name}, ${address?.city?.name}, ${address?.province?.name}`})
      }
      setSelectedAddress(selectedAddress);
      let addrList = setAddressLabel(addressList);
      let addr = addrList.find((addr) => addr.id === address.id)
      if (!!addr) {
        let processedAddress = addrList.map((adr) =>
          adr.id === address.id ? {...adr, ...address} : adr,
        )
        setAddressList(processedAddress)
      } else {
        setAddressList([selectedAddress, ...addrList])
      }
      setNewAddress({})
      setModalData(undefined)
    }
  }, [address])

  const setAddressLabel = (addressList) => {
    return addressList?.filter((address) =>
      !isEmpty(address.area) ||  !isEmpty(address.province) || !isEmpty(address.city))
      .map((address) => ({
        ...address,
        address: `${address?.area?.name}, ${address?.city?.name}, ${address?.province?.name}`
      }))
  }

  useEffect(() => {
    setModalData(undefined)
    setActiveModalComponent(undefined)
  }, [])

  const setFormData = (input, data) => {
    setModalData({...data, ...input})
  }

  const initFormData = () => {
    setModalData({
      direction: {
        intake: '',
        afternoon: false,
        bed_time: false,
        evening: false,
        morning: false,
      },
      frequency_unit: '',
      duration_unit: '',
      frequency: '',
      duration: '',
      quantity: '',
      advice: '',
      item: '',
      label: '',
    })
  }

  const onFormSubmit = (modalData) => {
    dispatch(createPrescriptions({orderId: order_id, payload: modalData}))
  }

  const onDelete = (selectedPrescription) => {
    dispatch(
      deletePrescription({
        orderId: order_id,
        prescriptionId: selectedPrescription.id,
      }),
    )
  }

  const ModalOptions = {
    createPrescriptions: {
      title: 'Create Prescriptions',
      child: ({modalData}) => (
        <PrescriptionForm setFormData={setFormData} modalData={modalData}/>
      ),
      onComplete: ({modalData}) => (
        <CustomButton
          disabled={
            processing || !ModalOptions.createPrescriptions.validate(modalData)
          }
          onClick={() => onFormSubmit(modalData)}
        >
          Ok
        </CustomButton>
      ),
      validate: (modalData) => {
        return (
          !isEmpty(modalData?.item) &&
          !isEmpty(modalData?.label) &&
          !isEmpty(modalData?.quantity)
        )
      },
    },
    deletePrescription: {
      title: 'Delete Prescriptions',
      child: () => <div>Do you want to delete this prescription ?</div>,
      onComplete: ({selectedPrescription}) => (
        <CustomButton
          disabled={processing}
          onClick={() => onDelete(selectedPrescription)}
        >
          Ok
        </CustomButton>
      ),
    },
    addLandmark: {
      title: 'Add Landmark',
      child: ({modalData}) => {
        return (
          <div>
            <Input
              type="text"
              label="Title*"
              placeholder="Title"
              onChange={(e) => {
                setFormData({...modalData, title: e.target.value}, modalData)
              }}
              value={modalData?.title}
            />
            <Input
              type="text"
              label="Landmark"
              placeholder="Landmark"
              onChange={(e) => {
                setFormData(
                  {...modalData, landmark: e.target.value},
                  modalData,
                )
              }}
              value={modalData?.landmark}
            />
          </div>
        )
      },
      onComplete: ({newAddress, modalData}) => (
        <CustomButton
          disabled={processing || !ModalOptions.addLandmark.validate(modalData)}
          onClick={() => {
            if (newAddress.hasOwnProperty('default_address')) {
              const addr = {...newAddress}
              delete addr['id']
              dispatch(
                updateAddress({
                  addressId: newAddress.id,
                  address: {
                    ...addr,
                    landmark: modalData.landmark,
                    title: modalData.title,
                    patient: prescriptionInfo?.requested_for?.id,
                  },
                }),
              )
            } else {
              dispatch(
                addAddress({
                  userId: prescriptionInfo?.requested_for?.id,
                  address: {
                    ...newAddress,
                    landmark: modalData.landmark,
                    title: modalData.title,
                  },
                }),
              )
            }
          }}
        >
          Ok
        </CustomButton>
      ),
      validate: (modalData) => {
        return !isEmpty(modalData?.landmark)
      },
    },
  }

  const onDeletePrescription = (prescription) => {
    setModalData({})
    setActiveModalComponent(ModalOptions.deletePrescription)
    setSelectedPrescription(prescription)
  }

  const confirmOrderPrescription = () => {
    dispatch(
      confirmOrder({
        payload: {
          products: prescriptionInfo.prescriptions.map((prescription) => {
            return {
              product_id: prescription?.product_id,
              discount: prescription?.discount,
              quantity: prescription?.quantity,
              unit_price: prescription?.unit_price,
              weight: prescription?.weight
            }
          }),
          shipping_address_id: selectedAddress.id,
        },
        prescriptionId: prescriptionInfo.id,
      })
    )
  }

  return (
    <div className="h-auto px-3 -mt-24 md:px-8">
      <div className="container max-w-full mx-auto">
        <div className="px-4 mb-16 grid grid-cols-1">
          <CustomCard>
            <CustomCardHeader contentPosition="none">
              <div className="flex items-center justify-between w-full">
                <h2 className="text-2xl text-white">Create Prescriptions</h2>
                <div className="flex space-x-4">
                  {!isEmpty(prescriptionInfo?.prescriptions) && (
                    <>
                      <SemiTransparentButton
                        disabled={isEmpty(selectedAddress) || !selectedAddress.hasOwnProperty('landmark') || selectedAddress?.area?.disabled}
                        onClick={() => {
                          confirmOrderPrescription()
                        }}
                      >
                        Confirm Order
                      </SemiTransparentButton>
                      {prescriptionInfo.type === 'SCANNED' && (
                        <SemiTransparentButton
                          onClick={() => {
                            dispatch(sendQuotation(order_id))
                          }}
                        >
                          Send Quotation
                        </SemiTransparentButton>
                      )}
                    </>
                  )}
                  <SemiTransparentButton
                    onClick={() => {
                      setActiveModalComponent(ModalOptions.createPrescriptions)
                      initFormData()
                    }}
                  >
                    + Add Prescriptions
                  </SemiTransparentButton>
                </div>
              </div>
            </CustomCardHeader>
            <CardBody>
              {loading || isEmpty(prescriptionInfo) || !isEmpty(error) ? (
                <JobCardLoader
                  count={1}
                  keyName={'Prescription'}
                  paddingTop="35"
                  loading={loading}
                  error={error.error}
                  isEmpty={isEmpty(prescriptionInfo)}
                  retry={() => {
                    getPrescriptionInfo()
                  }}
                />
              ) : (
                <div className="flex w-auto space-x-5">
                  <ImagePreview
                    imageList={prescriptionInfo?.images}
                    ObjectKey="prescription_image"
                  />
                  <div className="w-full">
                    {!isEmpty(prescriptionInfo.prescriptions) && (
                      <PrescriptionCard
                        prescriptions={prescriptionInfo?.prescriptions}
                        onDelete={onDeletePrescription}
                      />
                    )}

                    <div className="flex flex-col">
                      <LabeledSelect
                        label="Shipping Address"
                        getOptionValue={(option) => option?.id}
                        getOptionLabel={(option) => option?.address}
                        placeholder="Shipping Address"
                        onChange={(address) => {
                          let addr = {...address}
                          if (
                            !address.hasOwnProperty('landmark') ||
                            !address?.landmark.length
                          ) {
                            setNewAddress(addr)
                            setModalData({})
                            setActiveModalComponent(ModalOptions.addLandmark)
                          } else {
                            setSelectedAddress(address)
                          }
                        }}
                        options={addressList}
                        value={selectedAddress}
                      />
                      {
                        !isEmpty(selectedAddress) &&  selectedAddress?.area?.disabled ?
                          <span className="mb-2 text-sm text-red-500">This address is disabled please add a new address</span> : <></>
                      }
                      {
                        isEmpty(selectedAddress) &&  isEmpty(addressList) ?
                          <span className="mb-2 text-sm text-red-500">No Address Found. Please add a new address</span> : <></>
                      }
                      {
                        !isEmpty(selectedAddress)  && !selectedAddress?.hasOwnProperty('landmark')  ?
                          <span className="mb-2 text-sm text-red-500">Landmark not found for the selected address please add a landmark</span> : <></>
                      }
                      <div className="ml-auto">
                        <CustomButton onClick={() => setIsAddressModalOpen(true)}>
                          + Add Address
                        </CustomButton>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </CardBody>
          </CustomCard>
          <CustomModal
            showModal={modalData}
            loading={processing}
            setShowModal={() => {
              setModalData(undefined)
              setActiveModalComponent(undefined)
            }}
            title={activeModalComponent?.title}
            children={activeModalComponent?.child({modalData})}
            button={activeModalComponent?.onComplete({
              modalData,
              processing,
              newAddress,
              selectedPrescription,
            })}
          />
        </div>
      </div>
      {
        isAddressModalOpen &&
        <AddressModal showModal={isAddressModalOpen} setShowModal={setIsAddressModalOpen}
                      customerId={prescriptionInfo?.requested_for?.id}/>
      }
    </div>
  )
}

const PrescriptionCard = ({prescriptions, onDelete}) => {
  return (
    <div>
      <div className="font-bold text-md">Prescriptions</div>
      <div className="h-5"/>
      {prescriptions?.map((prescription) => (
        <div
          key={prescription.id}
          className="p-3 mb-5 border rounded-lg bg-blue-50 space-y-2"
        >
          <div className="flex justify-between ">
            <div className="text-sm font-bold">{prescription.label}</div>
            <IconButton
              icon="delete"
              size="xxl"
              onClick={() => onDelete(prescription)}
            />
          </div>
          <div className="flex p-2 bg-white rounded-lg">
            <div className="flex flex-col">
              <div className="mr-2 text-sm font-thin text-slate-500">
                Quantity:{' '}
              </div>
              <div>{prescription.quantity}</div>
            </div>
            <div className="w-5"/>
            <div className="flex flex-col">
              <div className="mr-2 text-sm font-thin text-slate-500">
                Unit Price(Rs):{' '}
              </div>
              <div>{prescription.unit_price}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default CreatePrescriptions
